import styled from "styled-components"
import { Link } from "react-router-dom"

export const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const Panel = styled.section<{ $span?: number; $dark?: boolean }>`
  grid-column: span ${({ $span = 6 }) => $span};
  min-width: 0;
  padding: clamp(1.35rem, 3vw, 2.25rem);
  border: 1px solid ${({ $dark }) => ($dark ? "rgba(139, 197, 235, 0.22)" : "#c4d0da")};
  border-radius: 2px;
  background: ${({ $dark }) => ($dark ? "#0a223a" : "#ffffff")};
  color: ${({ $dark }) => ($dark ? "#ffffff" : "#102840")};
  box-shadow: 0 18px 50px rgba(8, 36, 60, 0.06);

  @media (max-width: 900px) {
    grid-column: 1;
  }
`

export const PanelEyebrow = styled.p`
  margin: 0 0 0.7rem;
  color: #4e93c4;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.15em;
  text-transform: uppercase;
`

export const PanelTitle = styled.h2`
  margin: 0;
  font-size: clamp(1.45rem, 3vw, 2.3rem);
  font-weight: 620;
  line-height: 1.08;
  letter-spacing: -0.035em;
`

export const PanelText = styled.p`
  margin: 0.85rem 0 0;
  max-width: 720px;
  color: inherit;
  opacity: 0.72;
  line-height: 1.65;
`

export const ActionLink = styled(Link)<{ $secondary?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  margin-top: 1.35rem;
  padding: 0 1.2rem;
  border: 1px solid ${({ $secondary }) => ($secondary ? "#b9c9d6" : "#1d6da6")};
  border-radius: 2px;
  background: ${({ $secondary }) => ($secondary ? "transparent" : "#1d6da6")};
  color: ${({ $secondary }) => ($secondary ? "inherit" : "#ffffff")};
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 750;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 25px rgba(18, 69, 109, 0.16);
  }
`

export const ActionAnchor = styled.a<{ $secondary?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  margin-top: 1.35rem;
  padding: 0 1.2rem;
  border: 1px solid ${({ $secondary }) => ($secondary ? "#b9c9d6" : "#1d6da6")};
  border-radius: 2px;
  background: ${({ $secondary }) => ($secondary ? "transparent" : "#1d6da6")};
  color: ${({ $secondary }) => ($secondary ? "inherit" : "#ffffff")};
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 750;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 25px rgba(18, 69, 109, 0.16);
  }
`

export const Metrics = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  margin-top: 1.5rem;
  border-top: 1px solid rgba(133, 158, 179, 0.34);
`

export const Metric = styled.div`
  min-width: 0;
  padding: 1.1rem 1rem 0 0;

  strong {
    display: block;
    font-size: clamp(1.8rem, 4vw, 3rem);
    line-height: 1;
    letter-spacing: -0.05em;
  }

  span {
    display: block;
    margin-top: 0.45rem;
    color: inherit;
    opacity: 0.62;
    font-size: 0.78rem;
  }
`

export const Ledger = styled.div`
  margin-top: 1.2rem;
  border-top: 1px solid #cad5de;
`

export const LedgerRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1rem;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #d6dfe6;

  strong {
    display: block;
    margin-bottom: 0.25rem;
    color: #123858;
  }

  p {
    margin: 0;
    color: #667b8e;
    font-size: 0.86rem;
    line-height: 1.45;
  }

  time,
  > span {
    color: #667b8e;
    font-size: 0.78rem;
    white-space: nowrap;
  }
`

export const EmptyState = styled.div`
  padding: 2rem 0;
  color: #677c8e;
  line-height: 1.6;
`

export const ErrorNotice = styled.p`
  margin: 1rem 0 0;
  padding: 0.85rem 1rem;
  border-left: 3px solid #c8773a;
  background: #fff5ec;
  color: #77441f;
  font-size: 0.86rem;
`

export const PrimaryButton = styled.button`
  min-height: 48px;
  padding: 0 1.2rem;
  border: 1px solid #1d6da6;
  border-radius: 2px;
  background: #1d6da6;
  color: #ffffff;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 750;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #0d4172;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`
